import React from 'react';
import { formatCurrency } from '../../../Utils/Formatters';
import { PRODUCT_TYPE_COMPOSITE } from '../../../Utils/Constants/Product';
import { useTranslation } from 'react-i18next';

interface ProductPriceProps {
    product: any;
    showCents?: boolean;
    breakLine?: boolean;
    textFromPriceMuted?: boolean;
    classNameFromPriceText?: string;
    className?: string;
}

const ProductPrice = ({
    product,
    showCents=false,
    breakLine=true,
    textFromPriceMuted=true,
    classNameFromPriceText,
    className
}: ProductPriceProps) => {

    const { t } = useTranslation();

    return (
        <>
            {product.type === PRODUCT_TYPE_COMPOSITE
                ?   <span className={`inline leading-4 ${className}`}>
                        <span className={classNameFromPriceText}>{t('products.price_from_label')} </span>
                        {breakLine ? <br /> : ''}
                        {formatCurrency(product.default_price, showCents)}
                    </span>
                :   <span className={`inline leading-4 ${className}`}>
                        {parseFloat(product.from_price) > 0 && <span className={`text-[0.85em] ${textFromPriceMuted ? 'text-gray-400' : ''}`}><span className='font-regular line-through'>{ formatCurrency(product.from_price, showCents) }</span> </span>}
                        {(product.from_price > 0 && breakLine) ? <br /> : null}
                        <span className='font-medium'>{formatCurrency(product.price, showCents)}</span>
                    </span>
            }
        </>
    );
};

export default ProductPrice;
